module.exports = __webpack_public_path__ + "img/qiye.3b530770.png";